import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './CaseStudy.css';

/**
 * Legacy deep link: /case-study/:id/discussion
 * Resolves to the in-page Harvard Discussion section after exhibit count is known.
 */
const CaseDiscussionPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/case-study/${id}?focus=discussion`, { replace: true });
  }, [id, navigate]);

  return (
    <div className="case-study-page">
      <div className="case-study-loading">Opening Harvard discussion…</div>
    </div>
  );
};

export default CaseDiscussionPage;
